import type { Product } from '@packages/gql/generated/shopping/graphql';
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { EcoLabelFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { defineMessage, useIntl } from 'react-intl';
import { EcoLabel } from '../EcoLabel';

export type EcoLabelListProps = {
  ecoLabels: Product['ecoLabels'];
};

const message = defineMessage({
  defaultMessage: 'Nachhaltigkeit',
  id: 'ecoLabelList.dialog.headline',
});

/**
 * <p>This component renders all eco-labels of a product.</p>
 * <i>A product can have multiple eco-labels.</i>
 * */
export const EcoLabelList = ({ ecoLabels }: EcoLabelListProps) => {
  const { formatMessage } = useIntl();
  return (
    <Card>
      <CardHeader
        title={formatMessage(message)}
        sx={{
          borderBottom: 1,
          borderColor: 'grey.main',
          py: 1,
          px: 2,
        }}
      />
      <CardContent>
        <Stack gap={1.5}>
          {ecoLabels.map((ecoLabel, idx) => {
            if (!ecoLabel.iconUrl && !ecoLabel.license && !ecoLabel.text) {
              return null;
            }
            return (
              <EcoLabel
                // is disabled because this list is not being reordered
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                ecoLabelData={makeFragmentData(ecoLabel, EcoLabelFragmentFragmentDoc)}
              />
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};
